<template>
    <div>
        <!-- form to take user SOL as input and deposit into Marinade then Solend -->
        <b-form-group label="SOL" label-for="sol-input">
            <b-form-input id="sol-input" v-model="sol" type="number" placeholder="Enter SOL amount"></b-form-input>
        </b-form-group>
        <b-button @click="depositSol()">Deposit SOL</b-button>

    </div>
</template>

<script>

/*
import {Marinade, MarinadeConfig, Wallet, Provider, BN} from '@marinade.finance/marinade-ts-sdk'

import {useWallet} from 'solana-wallets-vue';
import {SolendAction, SolendMarket, SolendParams, SolendState} from '@solendprotocol/solend-sdk';
import {
    Connection,
    clusterApiUrl,
    Keypair,
    SystemProgram,
    Transaction,
    PublicKey,
    VersionedTransaction, TransactionMessage
} from '@solana/web3.js';
import {ElNotification} from "element-plus";

const connection = new Connection("https://solana-mainnet.rpc.extrnode.com", {
    commitment: 'processed',
    skipPreflight: true
})
const MY_REFERRAL_ACCOUNT = "9vvJCR6NWU4XmYE9MhrMFWn2jfvr6H1YdoYuXQt9RFbt" // <-- your referral account

const config = new MarinadeConfig({
    connection: connection,
    // publicKey: this.wallet.pubKey,
    // referralCode: new PublicKey(MY_REFERRAL_ACCOUNT),
})
const marinade = new Marinade(config)


export default {
    name: "SolendLoop",
    data() {
        return {
            msolsol: 0, // convert msol back to sol
            solmsol: 1.11171052798080240,
            solendParams: {},
            sol: .1, // sol to deposit
            solendBalance: 0, // solend balance
            wallet: useWallet(),
            solBalance: 0,
            msolBalance: 0,
            balances: {},
            marinade: {},
        }
    },
    mounted() {
        // this.getMarinadeParams()
        this.solendParams = this.getSolendParams()

        if (this.wallet.connected) {
            this.walletBalance()
            const config = new MarinadeConfig({
                connection: connection,
                publicKey: new PublicKey(this.wallet.publicKey),

                // referralCode: new PublicKey(MY_REFERRAL_ACCOUNT),
            })
            this.marinade = new Marinade(config)
        }

    },
    methods: {
        sendTx: async function (transaction) {
            try {
                console.log(transaction.serialize().length + " bytes")

                const txid = await this.wallet.sendTransaction(transaction, connection)
                console.log('sending transaction', txid)
                const result = await connection.confirmTransaction(txid, 'confirmed');
                if (result) {
                    ElNotification({
                        title: 'Success',
                        message: 'Successfully staked SOL for mSOL',
                        type: 'success',
                        duration: 5000,
                        customClass: 'text-left'
                    })

                } else {
                    ElNotification({
                        title: 'Error',
                        message: 'Transaction failed',
                        type: 'error',
                        customClass: 'text-left',
                        duration: 5000
                    })
                    this.error = "Transaction failed"
                }
            } catch (e) {
                console.log(e)
                this.error = e
                ElNotification({
                    title: 'Error',
                    message: "Transaction failed:\n" + e,
                    type: 'error',
                    customClass: 'text-left',
                    duration: 5000
                })
            }
            this.walletBalance()
            this.loading = false
        },
        getMarinadeParams() {
            axios.get('https://api.marinade.finance/msol/price_sol').then((response) => {
                console.log(response.data)
                // this.marinadeParams = response.data
                this.solmsol = response.data
                this.msolsol = 1 / response.data
            }).catch((error) => {
                console.log(error)
            })
        },
        async getSolendParams() {
            const market = await SolendMarket.initialize(
                connection,
                "production", // optional environment argument
                // new PublicKey("7RCz8wb6WXxUhAigok9ttgrVgDFFFbibcirECzWSBauM") // optional market address (TURBO SOL). Defaults to 'Main' market
            );
            console.log(market)
            return market
        },
        async depositSol() {
*/

            /****
             * Stopping here. What's happening?
             * - The transaction is too large to fit all accounts
             * - I'm also hitting a versioned transaction limit
             * - Ideally it seems we should be splitting this into multiple transactions
             * - This could be done with a signAll() then connection.sendTransaction
             * - However it seems I can't fit a stake, deposit and borrow into a single transaction
             * - So how can this be done atomically? You can't sign a failing transaction, and the borrow won't work until the deposit is complete
             * - Leaving this here to think about, but truth is it might need to be done on-chain. Which is a pain.
             */
/*
            console.log(this.sol)
            console.log(this.solendParams)
            // this.solendParams.deposit(sol)

            let loops = 1
            let solToDeposit = this.sol
            let msolToDeposit = 0
            let symbol = "mSOL"
            let collateral = 0
            let loopTransaction = new Transaction()
            let allTransactions = []
            // For each step of the loop:
            // 1. Deposit SOL into Marinade, receive msol @ x sol deposited = x*this.solmsol msol
            // 1. Deposit msol into Solend. Collateral is now msol LTV * msol deposited on this loop
            // 2. Withdraw max SOL from Solend. Collateral is now 0
            const m = this.marinade
            for (let i = 0; i < loops; i++) {
                // 1. Deposit to Marinade
                console.log("Deposit to Marinade " + solToDeposit + " SOL : " + new BN(solToDeposit * 1e9))
                const {
                    associatedMSolTokenAccountAddress,
                    transaction,
                } = await this.marinade.deposit(new BN(Number(solToDeposit).toFixed(9) * 1e9))
                // pop off the last transaction.instruction (the directed stake vote)
                transaction.instructions.pop()
                allTransactions.push(transaction)
                console.log(transaction, associatedMSolTokenAccountAddress.toString())
                for (let ix = 0; ix < transaction.instructions.length; ix++) {
                    loopTransaction.add(transaction.instructions[ix])
                }
                let msoltodeposit = solToDeposit / this.solmsol
                console.log("Deposit to Solend " + msoltodeposit + " mSOL : " + new BN(msoltodeposit * 1e9))
                let amountBase = new BN(msoltodeposit * 1e9)
                // 2. Deposit to Solend
                const solendAction = await SolendAction.buildDepositTxns(
                    connection,
                    amountBase,
                    symbol,
                    this.wallet.publicKey,
                    "production",
                    // new PublicKey("7RCz8wb6WXxUhAigok9ttgrVgDFFFbibcirECzWSBauM") // optional market address (TURBO SOL). Defaults to 'Main' market
                );
                console.log(solendAction)
                // if (i == 0) {
                    for (let ix = 0; ix < solendAction.setupIxs.length; ix++) {
                        loopTransaction.add(solendAction.setupIxs[ix])
                    }
                // }

                for (let ix = 0; ix < solendAction.lendingIxs.length; ix++) {
                    loopTransaction.add(solendAction.lendingIxs[ix])
                }
                // if (i == (loops - 1)) {
                    for (let ix = 0; ix < solendAction.cleanupIxs.length; ix++) {
                        loopTransaction.add(solendAction.cleanupIxs[ix])
                    }
                // }
                // this should probably use Solend's price not Marinade's or we may ask to borrow more than possible
                collateral = msoltodeposit * this.solmsol * .64
                console.log("Withdraw from Solend " + collateral + " SOL : " + new BN(collateral * 1e9))
                // 3. Withdraw from Solend
                const solendBorrowAction = await SolendAction.buildBorrowTxns(
                    connection,
                    collateral * 1e9,
                    'SOL',
                    this.wallet.publicKey,
                    "production",
                )
                console.log(solendBorrowAction)
                // if (i == 0) {
                    for (let ix = 0; ix < solendBorrowAction.setupIxs.length; ix++) {
                        loopTransaction.add(solendBorrowAction.setupIxs[ix])
                    }
                // }

                for (let ix = 0; ix < solendBorrowAction.lendingIxs.length; ix++) {
                    loopTransaction.add(solendBorrowAction.lendingIxs[ix])
                }
                // if (i == (loops - 1)) {
                    for (let ix = 0; ix < solendBorrowAction.cleanupIxs.length; ix++) {
                        loopTransaction.add(solendBorrowAction.cleanupIxs[ix])
                    }
                // }
                solToDeposit = collateral
            }
            // Final loop completed so we do one last deposit to Marinade with the remaining SOL
            if (solToDeposit > 0) {
                const {
                    associatedMSolTokenAccountAddress,
                    transaction,
                } = await this.marinade.deposit(new BN(solToDeposit * 1e9))
                allTransactions.push(transaction)
                for (let ix = 0; ix < transaction.instructions.length; ix++) {
                    // loopTransaction.add(transaction.instructions[ix])
                }
            }
            console.log(loopTransaction)
// let voteIx = await this.marinade.createDirectedStakeVoteIx(new PublicKey('EARNynHRWg6GfyJCmrrizcZxARB3HVzcaasvNa8kBS72'))
// loopTransaction.add(voteIx)
// we need to add the recent blockhash to the transaction
//             loopTransaction.recentBlockhash = (await connection.getRecentBlockhash()).blockhash
            await this.createAndSendV0Tx(loopTransaction.instructions)
            // lets try sending as a versioned transaction

            //console.log(loopTransaction)
            // await this.sendTx(loopTransaction)


        },
        async createAndSendV0Tx(txInstructions) {
            let latestBlockhash = await connection.getLatestBlockhash('confirmed');
            console.log("   ✅ - Fetched latest blockhash. Last Valid Height:", latestBlockhash.lastValidBlockHeight);
            const messageV0 = new TransactionMessage({
                payerKey: this.wallet.publicKey,
                recentBlockhash: latestBlockhash.blockhash,
                instructions: txInstructions
            }).compileToV0Message();
            console.log("   ✅ - Compiled Transaction Message");
            const transaction = new VersionedTransaction(messageV0);
            // await this.wallet.sendTransaction(transaction)
            await this.sendTx(transaction)
        },


        async walletBalance() {
            console.log(this.wallet.publicKey)
            let balance = await connection.getBalance(this.wallet.publicKey)
            console.log(balance, "balance")
            this.solBalance = balance / 1e9
            // get msol token balance
            // const msolTokenAccount = await this.marinade.getMSolTokenAccount(this.wallet.publicKey)
            // console.log(msolTokenAccount, "msolTokenAccount")
            // this.msolBalance = msolTokenAccount.amount / 1e9
            const accounts = connection.getParsedTokenAccountsByOwner(
                this.wallet?.publicKey,
                {programId: new PublicKey('TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA')}
            ).then(accounts => {
                let balances = {}
                accounts.value.forEach(account => {
                    const mint = account.account.data.parsed.info.mint
                    balances[mint] = account.account.data.parsed.info.tokenAmount.amount;

                })
                this.balances = balances
                console.log(this.balances)
                this.msolBalance = balances['mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So'] / 1e9 || 0
            })
        }
        ,


    },
    watch: {
        wallet: {
            handler: function (val, oldVal) {
                if (val.connected) {
                    const config = new MarinadeConfig({
                        connection: connection,
                        publicKey: new PublicKey(this.wallet.publicKey),
                        // referralCode: new PublicKey(MY_REFERRAL_ACCOUNT),
                    })
                    this.marinade = new Marinade(config)
                    this.walletBalance()
                } else {
                    this.solBalance = 0
                }
            }
            ,
            deep: true
        }
    }
    ,


}
*/
</script>

<style scoped>

</style>
